import React from 'react';
import PropType from 'prop-types';
import ConseilsPage from './conseilsPage';
import {ConseilsTeaser, Container, Conseils} from './styles';
import {withState} from 'recompose';
import {SmallTitle, MainTitle, Submit as ButtonMore, HeadlineSmall} from 'ui';

const RecipeConseils = ({pages, setPages, endReached, setEndReached}) => {
  const onEndReached = () => {
    setEndReached(true);
    setPages(pages - 1);
  };
  const conseilsPages = [];
  for (let page = 1; page <= pages; page++) {
    conseilsPages.push(<ConseilsPage onEndReached={onEndReached} key={page} page={page} />);
  }
  return (
    <Container>
      <SmallTitle>Conseils</SmallTitle>
      <MainTitle>Les astuces et gestes techniques</MainTitle>
      <HeadlineSmall>
        Pas à pas nous vous guidons sur la réalisation de gestes techniques ou d’astuces pour que vos
        desserts soient toujours parfaits.
      </HeadlineSmall>
      <Conseils>
        <ConseilsTeaser>{conseilsPages.map(conseilPage => conseilPage)}</ConseilsTeaser>
      </Conseils>
      {!endReached && <ButtonMore onClick={() => setPages(pages + 1)}>Voir plus d’astuces</ButtonMore>}
    </Container>
  );
};

RecipeConseils.propTypes = {
  pages: PropType.number.isRequired,
  setPages: PropType.func.isRequired,
  endReached: PropType.bool.isRequired,
  setEndReached: PropType.func.isRequired,
};

export default RecipeConseils
  |> withState('pages', 'setPages', 1)
  |> withState('endReached', 'setEndReached', false);
